import { render, staticRenderFns } from "./TestScreeningSingleCreate.vue?vue&type=template&id=5fee318e&scoped=true&"
import script from "./TestScreeningSingleCreate.vue?vue&type=script&lang=js&"
export * from "./TestScreeningSingleCreate.vue?vue&type=script&lang=js&"
import style0 from "./TestScreeningSingleCreate.vue?vue&type=style&index=0&id=5fee318e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee318e",
  null
  
)

export default component.exports